import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import ChevronLeftIcon from '../../../imgs/ChevronLeftIcon';
import Button from '../../../UI/Button/Button';
import {getSettings, getSiteCode, getSiteDataV2} from '../../selectors/selectors';
import Translation from '../../lang/Translation';
import Spacing from '../../style-helper/Spacing';

const useStyles = createUseStyles({
  backToBasketButton: {
    marginBottom: Spacing.single,
  },
  textContent: {
    display: 'flex',
    alignItems: 'center',
  },
});

export function ReturnToBasketCTA(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  return (
    <Button
      id="ReturnToBasketCTA__button"
      href={props.returnToBasketUrl ? props.returnToBasketUrl : props.constructedBackToBasketUrl}
      data-test="ReturnToBasketCTA__button"
      className={classes.backToBasketButton}
      noStyle
      link
      textOnly
      leftAlign
      noNewTab
    >
      <span className={classes.textContent}>
        <ChevronLeftIcon rtlSensitive />
        <Translation optionalExtension={props.siteCode}>btn.return.to.basket.text</Translation>
      </span>
    </Button>
  );
}

ReturnToBasketCTA.propTypes = {
  unsecureHomePageUrl: PropTypes.string.isRequired,
  constructedBackToBasketUrl: PropTypes.string.isRequired,
  returnToBasketUrl: PropTypes.string.isRequired,
  siteCode: PropTypes.string,
};

const mapStateToProps = (state) => {
  const unsecureHomePageUrl = getSiteDataV2(state).unsecureHomePageUrl;
  return {
    constructedBackToBasketUrl: `${unsecureHomePageUrl}my.basket`,
    returnToBasketUrl: getSettings(state).return_to_basket_url,
    siteCode: getSiteCode(state),
  }
};

export default connect(mapStateToProps)(ReturnToBasketCTA);
